import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProfileAvatar = ({ src, size = "45px" }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const username = user?.username || 'Explorer';
  const navigate = useNavigate();
  // Get first letter for the placeholder
  const initial = user?.username ? user.username.charAt(0).toUpperCase() : 'E';

  const handleClick = () => {
    if (user.role === 'parent') {
      navigate("/parent-dashboard");
    } else if (user.role === 'student') {
      navigate("/student/home");
    }
  };

  return (
    <div className="profile-avatar" style={{ width: size, height: size, cursor: 'pointer' }} onClick={handleClick}>
      {src ? (
        <img src={src} alt={username} className="avatar-img" />
      ) : (
        <div className="avatar-placeholder">
          {initial}
        </div>
      )}
      <div className="avatar-status-dot" />
    </div>
  );
};

export default ProfileAvatar;